import { render, staticRenderFns } from "./ModifyExpense.vue?vue&type=template&id=36d63b9c"
import script from "./ModifyExpense.vue?vue&type=script&lang=js"
export * from "./ModifyExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports